import moment from 'moment'
import React, { useState } from 'react'
import { Modal, Typography } from '@mui/material'

import Icons from 'components/Icons'
import ExpandedInfo from 'components/ExpandedInfo'
import styles from './styles'

const rows = [
  {
    id: 1,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 2,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 3,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 4,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 5,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 6,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 7,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 8,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 9,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
  {
    id: 10,
    last_update: moment().format('DD/MM/YYYY'),
    name: 'Jon da Silva',
    cpf: '123.456.789-00',
    id_greenhouse: 'ID Greenhouse',
    area: 'Area',
    role: 'Senioridade',
  },
]

const Collaborators = () => {
  const classes = styles()

  const [modal, setModal] = useState(false)
  const [clickedPerson, setClickedPerson] = useState({})

  function handleOpenModal(info) {
    setClickedPerson(info)
    setModal(true)
  }

  function handleCloseModal() {
    setClickedPerson({})
    setModal(false)
  }

  return (
    <div className={classes.root}>
      <div className={classes.pageHeader}>
        <div style={{ marginRight: 50 }}>
          <Typography variant="h6">Colaboradores</Typography>

          <p>
            Todas os colaboradores estão listados abaixo para acompanhamento.
          </p>
        </div>
      </div>

      <table className={classes.dataTable}>
        <thead>
          <tr>
            <th>Data da Revisão</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>ID Greenhouse</th>
            <th>Área de Atuação</th>
            <th>Senioridade</th>
            <th>Mídia Negativa</th>
            <th>PEP</th>
            <th>Processos Judiciais</th>
            <th>Listas Restritivas</th>
            <th>Pessoa vinculada</th>
            <th>Pendências financeiras</th>
            <th>Participação societária</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            return (
              <tr key={row.id} onClick={() => handleOpenModal(row)}>
                <td>{row.last_update}</td>
                <td>{row.name}</td>
                <td>{row.cpf}</td>
                <td>{row.id_greenhouse}</td>
                <td>{row.area}</td>
                <td>{row.role}</td>
                <td>
                  <Icons icon="error" />
                </td>
                <td>
                  <Icons icon="error" />
                </td>
                <td>
                  <Icons icon="error" />
                </td>
                <td>
                  <Icons icon="check" />
                </td>
                <td>
                  <Icons icon="check" />
                </td>
                <td>
                  <Icons icon="check" />
                </td>
                <td>
                  <Icons icon="check" />
                </td>
                <td>
                  <Icons icon="info" />
                </td>
                <td></td>
              </tr>
            )
          })}
        </tbody>
      </table>

      <Modal open={modal} onClose={handleCloseModal}>
        <div className={classes.modal}>
          <ExpandedInfo data={clickedPerson} handleClose={handleCloseModal} />
        </div>
      </Modal>
    </div>
  )
}

export default Collaborators
